export const EAN13Checksum = (number: string) => {
  const res = number
    .slice(0, 12)
    .split("")
    .map((n) => +n)
    .reduce((sum, a, idx) => (idx % 2 ? sum + a * 3 : sum + a), 0);

  const checksum = ((10 - (res % 10)) % 10) + "";
  return checksum;
};

export const EAN8Checksum = (number: string) => {
  const res = number
    .slice(0, 7)
    .split("")
    .map((n) => +n)
    .reduce((sum, a, idx) => (idx % 2 ? sum + a : sum + a * 3), 0);

  return ((10 - (res % 10)) % 10) + "";
};

export function validPLUProduct(props: {
  title?: string;
  eanCode?: string | null;
  eanType?: string | null;
  categoryId?: string | null;
}) {
  const validTitle = props.title && props.title.length > 0;

  const validEAN =
    props.eanCode === undefined ||
    props.eanCode === null ||
    props.eanCode.length === 0 ||
    props.eanType === "CODE39" ||
    props.eanType === "CODE128" ||
    (props.eanCode.length === 13 &&
      props.eanCode[12] === EAN13Checksum(props.eanCode)) ||
    (props.eanCode.length === 8 &&
      props.eanCode[7] === EAN8Checksum(props.eanCode));

  return validTitle && validEAN && props.categoryId;
}
